import { ProductPrice, ProductUnitOfMeasure } from '@msdyn365-commerce/retail-proxy';
import { getBooleanProperty, updateOrAddProperty } from './extension-properties-helpers';

const roundPriceTo2Decimals = (val?: number): number | undefined =>
    val === undefined ? undefined : Math.round((val + Number.EPSILON) * 100) / 100;

export const isPriceDifferentFromBase = (defaultPriceRow?: ProductPrice): boolean => {
    if (!defaultPriceRow) {
        return false;
    }

    const basePrice = roundPriceTo2Decimals(defaultPriceRow.BasePrice);
    if (basePrice === undefined) {
        return false;
    }

    const compare =
        defaultPriceRow.TradeAgreementPrice !== undefined
            ? roundPriceTo2Decimals(defaultPriceRow.TradeAgreementPrice)
            : roundPriceTo2Decimals(defaultPriceRow.CustomerContextualPrice);

    return compare !== undefined && compare !== basePrice;
};

export const isDiscountedPrice = (productPrice: ProductPrice): boolean => {
    const price = productPrice?.CustomerContextualPrice ?? productPrice?.BasePrice ?? 0;
    const basePrice = productPrice
        ? Math.max(productPrice.BasePrice ?? 0, productPrice.TradeAgreementPrice ?? 0, productPrice.AdjustedPrice ?? 0)
        : 0;
    const isDiscountPrice = basePrice > price;
    return isDiscountPrice;
};

export const getOriginalPrice = (price: ProductPrice): number => {
    return price.AdjustedPrice ?? price.TradeAgreementPrice ?? price.BasePrice ?? 0;
};

export const getBasePrice = (price: ProductPrice): number => {
    const basePrice = price ? Math.max(price.BasePrice ?? 0, price.TradeAgreementPrice ?? 0, price.AdjustedPrice ?? 0) : 0;
    return basePrice;
};

export const getActivePrice = (price: ProductPrice): number => {
    if (price.CustomerContextualPrice !== undefined) {
        return price.CustomerContextualPrice;
    }

    return getOriginalPrice(price);
};

export const setIsDisabledFlag = (uom: ProductUnitOfMeasure, shouldDisable: boolean): void => {
    if (uom) {
        if (!uom?.ExtensionProperties?.length) {
            uom.ExtensionProperties = [];
        }
        updateOrAddProperty('Disabled', { BooleanValue: shouldDisable }, uom.ExtensionProperties);
    }
};

export const isUomDisabled = (uom: ProductUnitOfMeasure): boolean => {
    return getBooleanProperty(uom?.ExtensionProperties, 'Disabled');
};
